import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import GeneralRouter from './components/GeneralRouter';
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { ThemeProvider } from "styled-components";
import defaultTheme from "./theme";
import { SnackbarProvider } from "notistack";
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { createRoot } from "react-dom/client";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { isStaging } from './components/Util/staging';

if (isStaging()) {
    const originalFetch = window.fetch;
    window.fetch = function (resource, init) {
        let url = typeof resource === 'string' ? resource : resource?.url;
        if (typeof resource === 'string') {
            resource = resource.replace('https://sv-nn.com', 'https://stage.sv-nn.com');
            url = resource;
        } else if (resource && typeof resource.url === 'string') {
            const newUrl = resource.url.replace('https://sv-nn.com', 'https://stage.sv-nn.com');
            resource = new Request(newUrl, resource);
            url = newUrl;
        }

        if (url && (url.includes('stage.sv-nn.com') || isStaging())) {
            init = init ? { ...init } : {};
            if (init.headers instanceof Headers) {
                init.headers = new Headers(init.headers);
                init.headers.set('X-Stage-Access', 'permitted');
            } else if (Array.isArray(init.headers)) {
                init.headers = [...init.headers, ['X-Stage-Access', 'permitted']];
            } else {
                init.headers = {
                    ...init.headers,
                    'X-Stage-Access': 'permitted'
                };
            }
        }

        return originalFetch.call(this, resource, init);
    };
}


const AdminParserLauncher = React.lazy(() => import('./components/AdminParserLauncher'));


// are we in admin page?
const $adminCont1 = document.querySelector('.TJS_AdminParserLauncher_Cont');
if ($adminCont1) {
    console.log("Initiaeing...");
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={<div>Загрузка...</div>}>
                <AdminParserLauncher sectionID={$adminCont1.dataset.sectionId} />
            </Suspense>
        </React.StrictMode>,
        $adminCont1
    );
} else {
    const domNode = document.getElementById('ts_react-app-root');
    const root = createRoot(domNode);

    root.render(<React.StrictMode>
        <HelmetProvider>
            <Helmet>
                <title>Стройся Волга</title>
                <link rel="canonical" href="https://sv-nn.com/" />
            </Helmet>
            <Provider store={store}>
                <ThemeProvider theme={defaultTheme}>
                    <SkeletonTheme>
                        <SnackbarProvider>
                            <GeneralRouter />
                        </SnackbarProvider>
                    </SkeletonTheme>
                </ThemeProvider>
            </Provider>
        </HelmetProvider>
    </React.StrictMode>);
    // ReactDOM.render(
    //     <React.StrictMode>
    //         <Provider store={store}>
    //             <ThemeProvider theme={defaultTheme}>
    //                 <SkeletonTheme>
    //                     <SnackbarProvider>
    //                         <GeneralRouter/>
    //                     </SnackbarProvider>
    //                 </SkeletonTheme>
    //             </ThemeProvider>
    //         </Provider>
    //     </React.StrictMode>,
    //     document.getElementById('ts_react-app-root')
    // test
    // );
}



